import { DefaultState, Filters } from 'store/types';

export const SET_REQUESTS_BY_CLIENT_TABLE_FILTERS = "SET_REQUESTS_BY_CLIENT_TABLE_FILTERS";

export type RequestsByClientTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetRequestsByClientTableFilters {
  type: typeof SET_REQUESTS_BY_CLIENT_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type RequestsByClientTableFiltersActionTypes = SetRequestsByClientTableFilters;
